import { useApiPost, useApiQuery } from '../api';
import { useBuildVars } from '../config';
import { useMutation } from 'react-query';
import { useFeatureFlagEnabled } from './useFeatureFlagEnabled';
import { IM_PRICING_GDE_UI_SECURITYGROUP_ENABLED } from 'src/util/constants';
import { useFeatureFlagsContext } from 'src/provider/FeatureFlagProvider';

export interface UserName {
  Usermailid: string;
}
export interface CountryCompanyCode {
  label: string;
  roleId: number;
  siteId: string;
  value: string;
}
export interface UserAccessDetails {
  defaultCountryCompanyCode: string;
  defaultRoleId: number;
  listOfAccessableCountries: CountryCompanyCode[];
  role: number[];
}

export function useGetUserRoles(params: UserName) {
  const { isLoading: isFeatureFlagsLoading } = useFeatureFlagsContext();
  const buildVars = useBuildVars();
  const isSecurityGroupEnabled = useFeatureFlagEnabled(
    IM_PRICING_GDE_UI_SECURITYGROUP_ENABLED
  );
  return useApiQuery<UserAccessDetails>(
    '/system.webapi.gds/api/v1/gdsCoreApiVendor/getAccess',
    params,
    { enabled: !isFeatureFlagsLoading && params.Usermailid !== '' },
    {
      'Gde-Sec-Group': isSecurityGroupEnabled ? 'yes' : 'no',
      'IM-CompanyCode': 'MD',
      'IM-CountryCode': 'US',
    },
    {
      host: buildVars.VP_API_BASE,
    }
  );
}

export interface UserRoleUpdateRequest {
  requestPreamble: {
    adminRole: number;
    countryMapping: string;
    defaultCountryCode: string;
    eventType: string;
    requestNumber: string;
    userId: string;
    userRole: number;
  };
}

export interface UserRoleUpdateResponse {
  message: string;
  responsePreamble: {
    errors: any[] | null;
    transactionID: string;
    transactionStatus: string;
  };
  statusCode: number;
}

export function useUserRoleUpdate() {
  const buildVars = useBuildVars();
  const apiPost = useApiPost<UserRoleUpdateResponse>({
    host: buildVars.VP_API_BASE,
  });
  return useMutation((request: UserRoleUpdateRequest) =>
    apiPost(
      '/system.webapi.gds/api/v1/gdsCoreApiVendor/CreateUpdateDeleteUserRole',
      request,
      undefined,
      {
        APPGDEUI: process.env.REACT_APP_APPGDEUI,
        'IM-CompanyCode': 'MD',
        'IM-CountryCode': 'US',
      }
    )
  );
}
